import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { verifyToken } from '../actions/company'

const EnsureAuth = ({ component: Component, verifyToken, ...rest }) => {
  const { currentAdmin, loading } = rest.company
  const token = localStorage.getItem('Authorization')

  if (!currentAdmin && token) {
    verifyToken(token)
    if (loading) {
      return <div />
    }
  }

  return (
    <Route
      path={rest.path}
      render={props =>
        currentAdmin ? <Component {...props} {...rest} /> : <Redirect to="/" />
      }
    />
  )
}

const mapStateToProps = ({ company }) => {
  return { company }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ verifyToken }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EnsureAuth)
